//      
                                                    
                                                                     
import getScroll from './get-scroll';
import { canScrollDroppable } from '../can-scroll';

              
                                
                
                   
                        
                                  
   

export default ({
  droppable,
  subject,
  center,
  dragStartTime,
  shouldUseTimeDampening,
}      )            => {
  // We know this has a closestScrollable
  const frame              = droppable.frame;

  // this should never happen - just being safe
  if (!frame) {
    return null;
  }

  const scroll            = getScroll({
    dragStartTime,
    container: frame.pageMarginBox,
    subject,
    center,
    shouldUseTimeDampening,
  });

  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/auto-scroller/fluid-scroller/get-droppable-scroll-change.js